import type {QuoteFont} from '../resolver/types';

export const FONT_OPTIONS: Array<{value: QuoteFont; labelId: string}> = [
	{value: 'helvetica', labelId: 'quote_designer.font.helvetica'},
	{value: 'times', labelId: 'quote_designer.font.times'},
	{value: 'courier', labelId: 'quote_designer.font.courier'},
];

// Helvetica, Times and Courier are built-in to @react-pdf — no font registration needed.
// Additional faces would require bundling their .ttf binaries.
export function registerQuoteFonts(): void {
	// no-op for the current font set
}

export function fontFamily(font: QuoteFont): string {
	switch (font) {
		case 'times':
			return 'Times-Roman';
		case 'courier':
			return 'Courier';
		default:
			return 'Helvetica';
	}
}
